(function() {
	'use strict';

	var sideAlertError = {
			template : '<div class="alerts">' +
            		   		'<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
            		   			'<uib-alert type="{{alert.type}}" close="alert.close($ctrl.alerts)">{{ alert.msg }}</uib-alert>' +
            		   		'</div>' +
            		   	'</div>'+
            		   	'</br>'	+
            		   	'<div class="alerts">' +
        		   			'<div ng-repeat="alert in $ctrl.alerts2" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
        		   				'<uib-alert type="{{alert.type}}" close="alert.close($ctrl.alerts2)">{{ alert.msg }}</uib-alert>' +
        		   			'</div>' +
        		   		'</div>'+
        		   		'</br>'	+
            		   	'<div class="alerts">' +
        		   			'<div ng-repeat="alert in $ctrl.alerts3" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
        		   				'<uib-alert type="{{alert.type}}" close="alert.close($ctrl.alerts3)">{{ alert.msg }}</uib-alert>' +
        		   			'</div>' +
        		   		'</div>'
            		   		,
			controller: sideAlertErrorController
		};
	
	angular.module('sideApp')
	.component('sideAlertError', sideAlertError);
	
    sideAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope'];

    function sideAlertErrorController ($scope, AlertService, $rootScope) {
    	var vm = this;

        vm.alerts = [];
        vm.alerts2 = [];
        vm.alerts3 = [];
        
        
        
		function addErrorAlert(message, key, data) {
			var array = message.split('.');
			angular.forEach(array, function(value, key) {
				if (value != null && value != '') {
					vm.alerts.push(AlertService.add({
						type : 'danger',
						msg : value,
						toast : AlertService.isToast(),
						scoped : true
					}, vm.alerts));
				}
			});
		}
		
		function addGoodAlert(message, key, data) {
			var array = message.split('.');
			angular.forEach(array, function(value, key) {
				if (value != null && value != '') {
					vm.alerts2.push(AlertService.add({
						type : 'success',
						msg : value,
						toast : AlertService.isToast(),
						scoped : true
					}, vm.alerts2));
				}
			});
		}
		
		function addClasesAlert(message, key, data) {
			var array = message.split('.');
			angular.forEach(array, function(value, key) {
				if (value != null && value != '') {
					vm.alerts3.push(AlertService.add({
						type : 'success',
						msg : value,
						toast : AlertService.isToast(),
						scoped : true
					}, vm.alerts3));
				}
			});
		}

        var cleanHttpErrorListener = $rootScope.$on('sideApp.httpError', function (event, httpResponse) {
        	var i;
            event.stopPropagation();
            var errorHeader = httpResponse.headers('X-sideApp-error');
            var entityKey = httpResponse.headers('X-sideApp-params');
            var errorHeader2 = httpResponse.headers('X-sideApp-good');
            var entityKey2 = httpResponse.headers('X-sideApp-paramsV2');
            var errorHeader3 = httpResponse.headers('X-sideApp-clases');
            var entityKey3 = httpResponse.headers('X-sideApp-paramsV3');
            
            switch (httpResponse.status) {
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;
            
            case 200:
                 if (errorHeader) {
                     var entityName = entityKey;
                     addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                 }
                 if (errorHeader2) {
                     var entityName = entityKey2;
                     addGoodAlert(errorHeader2, errorHeader2, {entityName: entityName});
                 }
                 if (errorHeader3) {
                     var entityName = entityKey3;
                     addGoodAlert(errorHeader3, errorHeader3, {entityName: entityName});
                 }
                 
            	break;

            case 400:
                if (errorHeader) {
                    var entityName = entityKey;
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = convertedField.charAt(0).toUpperCase() + convertedField.slice(1);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                
                if (errorHeader2) {
                    var entityName = entityKey2;
                    addGoodAlert(errorHeader2, errorHeader2, {entityName: entityName});
                }
                if (errorHeader3) {
                    var entityName = entityKey3;
                    addGoodAlert(errorHeader3, errorHeader3, {entityName: entityName});
                }
                
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        var cleanHttpInfoListener = $rootScope.$on('sideApp.httpInfo', function (event, httpResponse) {
        	var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            case 200:
            	 var errorHeader = httpResponse.headers('X-sideApp-error');
                 var entityKey = httpResponse.headers('X-sideApp-params');
                 var errorHeader2 = httpResponse.headers('X-sideApp-good');
                 var entityKey2 = httpResponse.headers('X-sideApp-paramsV2');
                 var errorHeader3 = httpResponse.headers('X-sideApp-clases');
                 var entityKey3 = httpResponse.headers('X-sideApp-paramsV3');
                 if (errorHeader) {
                     var entityName = entityKey;
                     addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                 }
                 if (errorHeader2) {
                     var entityName = entityKey2;
                     addGoodAlert(errorHeader2, errorHeader2, {entityName: entityName});
                 }
                 if (errorHeader3) {
                     var entityName = entityKey3;
                     addGoodAlert(errorHeader3, errorHeader3, {entityName: entityName});
                 }
                 
            	break;

            default:
//                if (httpResponse.data && httpResponse.data.message) {
//                    addErrorAlert(httpResponse.data.message);
//                } else {
//                    addErrorAlert(angular.toJson(httpResponse));
//                }
            }
        	
        });
        
        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
            if(angular.isDefined(cleanHttpInfoListener) && cleanHttpInfoListener !== null){
            	cleanHttpInfoListener();
                vm.alerts = [];
            }
        });
    }
})();